import {
  getSelectedProposalSearchValueFromUrl,
  resolveSelectedProposalIdForVersion,
} from '@client/hooks/use-selected-proposal-id.hooks';
import type { Baseline } from '@shared/models/project.model';
import type { ProposalId } from '@shared/models/proposals.model';

/**
 * Proposal the open version is showing. Explicit baseline (`?proposal=baseline`)
 * is `undefined`. Both targets group and deactivate by SBEF code; `undefined`
 * writes that on the version.
 */
export const selectedProposalIdForVersion = (
  version: Baseline,
): ProposalId | undefined =>
  resolveSelectedProposalIdForVersion(
    getSelectedProposalSearchValueFromUrl(),
    version.proposals.map(({ id }) => id),
  );
